document.addEventListener("DOMContentLoaded", function () {

  const countdowns = document.querySelectorAll("[data-rt-countdown-root]");

  countdowns.forEach(function (el) {

    const target = new Date(
      el.dataset.countdownTarget
    ).getTime();


    function updateCountdown(){

      const now = new Date().getTime();
      const distance = target - now;


      if(distance <= 0){
        el.style.display = "none";
        return;
      }


      const days = Math.floor(
        distance / (1000 * 60 * 60 * 24)
      );

      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24))
        /(1000 * 60 * 60)
      );

      const minutes = Math.floor(
        (distance % (1000 * 60 * 60))
        /(1000 * 60)
      );

      const seconds = Math.floor(
        (distance % (1000 * 60))
        /1000
      );


      el.querySelector("[data-days]").textContent =
        String(days).padStart(2,'0');

      el.querySelector("[data-hours]").textContent =
        String(hours).padStart(2,'0');

      el.querySelector("[data-minutes]").textContent =
        String(minutes).padStart(2,'0');

      el.querySelector("[data-seconds]").textContent =
        String(seconds).padStart(2,'0');

    }


    updateCountdown();

    setInterval(updateCountdown,1000);

  });

});